export default __webpack_public_path__ + "static/media/Bubonic_Bastards.7a009ccd.png";